import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const BoostIconLight = ({
  inactive,
  activeFill,
  inactiveFill,
  ...props
}: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
  inactive?: boolean;
  activeFill?: string;
  inactiveFill?: string;
}) => {
  return (
    <SvgWrapper
      viewBox="0 0 177 211"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.8579 11.1519C86.076 -9.78975 119.193 0.690725 119.592 26.5747L120.195 65.7114H149.209C171.088 65.7115 183.843 90.4098 171.178 108.25L106.793 198.94C91.5978 220.344 57.8837 209.594 57.8833 183.344V144.292H26.9897C4.97521 144.292 -7.74655 119.32 5.19482 101.511L70.8579 11.1519ZM108.368 26.7476C108.135 11.6486 88.8162 5.53455 79.939 17.7505L14.2759 108.111L13.9331 108.601C7.07104 118.787 14.1173 132.618 26.3911 133.055L26.9897 133.066H62.3735C66.0933 133.066 69.1088 136.081 69.1089 139.801V183.344L69.1235 184.055C69.712 198.613 88.3093 204.543 97.2163 193.013L97.6401 192.442L162.025 101.75C169.297 91.5067 162.201 77.3867 149.804 76.9478L149.209 76.937H115.774L115.431 76.9282C112.024 76.7575 109.277 74.0524 109.053 70.6479L109.039 70.3052L108.368 26.7476ZM86.0317 30.3735C89.4237 25.6225 96.9153 28.0223 96.9155 33.8599V82.6079C96.9155 85.9216 99.6018 88.6079 102.916 88.6079H144.195C149.074 88.6079 151.913 94.1229 149.078 98.0942L90.9595 179.5C87.5674 184.25 80.077 181.85 80.0767 176.013V127.265C80.0767 123.951 77.3903 121.265 74.0767 121.265H32.7974C27.9178 121.265 25.0785 115.75 27.9136 111.779L86.0317 30.3735Z"
        fill={inactive ? inactiveFill || '#ffffff' : activeFill || '#D4B9FF'}
      />
    </SvgWrapper>
  );
};
